import { NavLink, useNavigate } from 'react-router-dom';
import EaseeLogo from '../../assets/icons/easee-logo-white.svg?react';
import { useAuth } from 'react-oidc-context';
import { isDevMode } from '../Auth/auth';
import { clearDevToken } from '../Auth/DevAuth';
import { resetStaticDataCache } from '../../StaticDataProvider';
import { clearLastVisitedUrl } from '../Hooks/urlPersistence';

export const NavBar = () => {
  const navigate = useNavigate();
  // isDevMode is a build-time constant, so this never varies across renders
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const auth = isDevMode ? null : useAuth();

  const handleLogout = () => {
    clearLastVisitedUrl();
    resetStaticDataCache();
    if (isDevMode) {
      clearDevToken();
      navigate('/login');
    } else {
      auth?.removeUser();
    }
  };

  return (
    <div
      className="h-14 pl-3.5 flex justify-start"
      style={{ backgroundColor: '#4B5058', color: 'white' }}
    >
      <div className="pt-5">
        <NavLink to="/products" end aria-label="Products">
          <EaseeLogo width="75px" />
        </NavLink>
      </div>
      <div className="pl-10 pt-4">
        <NavLink
          to="/services"
          className={({ isActive }) =>
            isActive ? 'font-semibold underline' : undefined
          }
        >
          Services
        </NavLink>
      </div>
      <div className="pl-10 pt-4">
        <NavLink
          to="/users"
          className={({ isActive }) =>
            isActive ? 'font-semibold underline' : undefined
          }
        >
          Users
        </NavLink>
      </div>
      <div className="pr-10 pt-4 ml-auto">
        <button
          type="button"
          onClick={handleLogout}
          className="text-white"
        >
          Log out
        </button>
      </div>
    </div>
  );
};
